export default __webpack_public_path__ + "static/media/Blackruin.1fd46ae7.jpg";